// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"63":"NotFoundPage","703":"HomePage"}[chunkId] || chunkId) + "." + {"63":"fb6bd0da","440":"812cfa50","703":"080f4a49"}[chunkId] + ".chunk.js";
};